import { IWhatsappStatus } from '../../interfaces/charts/trader-advisor.interface';
import { TraderAdvisorAction } from './trader-advisor.action';

export class TraderAdvisorState {
    public Accuracy: number;
    public pendingAccuracy: boolean;
    public Appt: number;
    public pendingAppt: boolean;
    public Dailydiscipline: Object;
    public pendingDailydiscipline: boolean;
    public LossesGreaterThanAverage: [];
    public pendingLossesGreaterThanAverage: boolean;
    public WhatsappStatus: IWhatsappStatus;
    public pendingWhatsappStatus: boolean;
    public errors: any;
}

export const initialState: TraderAdvisorState = {
    Accuracy: 0,
    pendingAccuracy: false,

    Appt: 0,
    pendingAppt: false,

    Dailydiscipline: {},
    pendingDailydiscipline: false,

    LossesGreaterThanAverage: [],
    pendingLossesGreaterThanAverage: false,

    WhatsappStatus: { ClientCode: 0, Signature: null, Status: 0 },
    pendingWhatsappStatus: false,

    errors: null,
};

export function TraderAdvisorReducer(
    state: TraderAdvisorState = initialState,
    action: TraderAdvisorAction,
): TraderAdvisorState {

    switch (action.type) {
        case TraderAdvisorAction.getAccuracy:
            return { ...state, ...{ pendingAccuracy: true }};
        case TraderAdvisorAction.getAccuracyError:
            return { ...state, ...{ errors: action.payload, pendingAccuracy: false }};
        case TraderAdvisorAction.getAccuracySuccess:
            return { ...state, ...{ Accuracy: action.payload.Accuracy, pendingAccuracy: false }};

        case TraderAdvisorAction.getAppt:
            return { ...state, ...{ pendingAppt: true }};
        case TraderAdvisorAction.getApptError:
            return { ...state, ...{ errors: action.payload, pendingAppt: false }};
        case TraderAdvisorAction.getApptSuccess:
            return { ...state, ...{ Appt: action.payload.Appt, pendingAppt: false }};

        case TraderAdvisorAction.getDailydiscipline:
            return { ...state, ...{ pendingDailydiscipline: true }};
        case TraderAdvisorAction.getDailydisciplineError:
            return { ...state, ...{ errors: action.payload, pendingDailydiscipline: false }};
        case TraderAdvisorAction.getDailydisciplineSuccess:
            return { ...state, ...{ Dailydiscipline: action.payload, pendingDailydiscipline: false }};

        case TraderAdvisorAction.getLossesGreaterThanAverage:
            return { ...state, ...{ pendingLossesGreaterThanAverage: true }};
        case TraderAdvisorAction.getLossesGreaterThanAverageError:
            return { ...state, ...{ errors: action.payload, pendingLossesGreaterThanAverage: false }};
        case TraderAdvisorAction.getLossesGreaterThanAverageSuccess:
            return { ...state, ...{ LossesGreaterThanAverage: action.payload, pendingLossesGreaterThanAverage: false }};

        case TraderAdvisorAction.getWhatsappStatus:
            return { ...state, ...{ pendingWhatsappStatus: true }};
        case TraderAdvisorAction.getWhatsappStatusError:
            return { ...state, ...{ errors: action.payload, pendingWhatsappStatus: false }};
        case TraderAdvisorAction.getWhatsappStatusSuccess:
            return { ...state, ...{ WhatsappStatus: action.payload, pendingWhatsappStatus: false }};

        case TraderAdvisorAction.setWhatsappStatus:
            return { ...state, ...{ pendingWhatsappStatus: true }};
        case TraderAdvisorAction.setWhatsappStatusError:
            return { ...state, ...{ errors: action.payload, pendingWhatsappStatus: false }};
        case TraderAdvisorAction.setWhatsappStatusSuccess:
            return { ...state, ...{ WhatsappStatus: action.payload, pendingWhatsappStatus: false }};

        default:
            return state;
    }
}
